import { Component } from 'react';
import styled, { css } from 'styled-components';

const Style = styled.div<{
  priceCategoryId: number;
  textColor: string;
  secondaryTextColor: string;
}>`
  span {
    color: ${(props: { textColor: string }) => props.textColor};
  }

  ${(props: { priceCategoryId: number }) =>
    props.priceCategoryId &&
    css`
      span:nth-child(n + ${props.priceCategoryId + 1}):nth-child(-n + 4) {
        color: ${(props: { secondaryTextColor: string }) => props.secondaryTextColor};
      }
    `}
`;

type Props = {
  priceCategoryId: number;
  color?: string | undefined;
  secondaryColor?: string | undefined;
};

export default class PriceIndicator extends Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    return (
      <Style
        priceCategoryId={this.props.priceCategoryId}
        textColor={this.props.color || '#1c1c1c'}
        secondaryTextColor={this.props.secondaryColor || '#dadada'}
      >
        <span>$</span>
        <span>$</span>
        <span>$</span>
        <span>$</span>
      </Style>
    );
  }
}
